import type { FC } from 'react';

import { Button } from '@zen/DesignSystem';
import { bookingWizardRoutes } from '@zen/Routes';
import { useNavigationHistory } from '@zen/utils/NavigationHistory';

const BookShipmentButton: FC = () => {
  const { navigate } = useNavigationHistory();

  const handleClick = (): void => {
    navigate(bookingWizardRoutes.index.getUrl());
  };

  return (
    <Button data-component="book-shipment-button" onClick={handleClick} variant="primary">
      Book shipment
    </Button>
  );
};

export default BookShipmentButton;
